import { cn } from '../../utils/cn'

export default function SectionHeader({
  number,
  label,
  eyebrow,
  title,
  quote,
  quoteClass = 'font-inter-light text-[28px] italic text-[#454545]',
  titleClass,
  leftClass,
}) {
  return (
    <div className="w-full px-20">
      <div className="flex items-center gap-[17px] py-8">
        <span className="font-inter-regular text-2xl text-[#AEAEAE]">
          {number}
        </span>
        <span className="rounded-lg bg-[#EAEAEA] px-6 py-2 font-inter-regular text-2xl text-[#707070]">
          {label}
        </span>
      </div>

      <div className="flex flex-col justify-between gap-10 pb-6 md:flex-row">
        <div
          className={cn('flex flex-col gap-[24px] md:max-w-[548px]', leftClass)}
        >
          {eyebrow && (
            <span className="font-inter-extrabold text-2xl text-[#454545]">
              {eyebrow}
            </span>
          )}
          <h1
            className={cn(
              'font-inter-black text-[40px] leading-[1.25] tracking-[-0.02em] text-[#454545]',
              titleClass,
            )}
          >
            {title}
          </h1>
        </div>

        {quote && <p className={cn('md:max-w-[564px]', quoteClass)}>{quote}</p>}
      </div>
    </div>
  )
}
